import gql from 'graphql-tag'

export default {
  
  // 获取首页数据，包括banner图片，最新专辑，美女图片标签
  GET_HOME_DATA: gql`
    query GET_HOME_DATA(
      $bannerLocationKey:String!,
      $labelLocationKey:String!,
      $distributionPlatform:DistributionPlatform!,
      $cubeListCategory:MomentListCategory!,
      $type:CubeType!,
      $page:Int!,
      $pageSize:Int!){  
      getWebBanners(locationKey:$bannerLocationKey){
        title
        alt
        url
        destination
      }
      getWebCubesByType(
        distributionPlatform:$distributionPlatform,
        cubeListCategory:$cubeListCategory,
        type:$type,
        page:$page,
        pageSize:$pageSize){
        list{
          album{
            id
            contentId
            title
            cover314 {
              url
            }
          }
        }
      }
      getWebTextLabelConfig(locationKey: $labelLocationKey){
        chinese
        pinyin
        parentLabel {
          pinyin
          chinese
        }
      }
      
    }`,
  // 获取最新写真列表
  GET_LAST_ALBUM_LIST:  gql`
    query GET_WEB_PHOTO_LIST(
      $distributionPlatform:DistributionPlatform!,
      $cubeListCategory:MomentListCategory!,
      $type:CubeType!,
      $page:Int!,
      $pageSize:Int!
    ){
      getWebCubesByType(
        distributionPlatform:$distributionPlatform,
        cubeListCategory:$cubeListCategory,
        type:$type,
        page:$page,
        pageSize:$pageSize){
        list{
          album{
            id
            contentId
            title
            cover314 {
              url
            }
          }
        }
      }
    }`,

  // 获取尤果内衣列表
  GET_WEB_SHOP_LIST: gql`
    query GET_WEB_SHOP_LIST(
      $distributionPlatform:DistributionPlatform!,
      $cubeListCategory:MomentListCategory!,
      $type:CubeType!,
      $page:Int!,
      $pageSize:Int!
    ){
      getWebCubesByType(
        distributionPlatform:$distributionPlatform,
        cubeListCategory:$cubeListCategory,
        type:$type,
        page:$page,
        pageSize:$pageSize){
        total
        list{
          commodity{
            id
            title
            coverPhoto{
              url
            }
          }
        }
      }
    }`,

  // 获取写真列表
  GET_WEB_PHOTO_LIST: gql`
    query GET_WEB_PHOTO_LIST(
      $distributionPlatform:DistributionPlatform!,
      $cubeListCategory:MomentListCategory!,
      $type:CubeType!,
      $page:Int!,
      $pageSize:Int!
      $locationKey:String!
    ){
      getWebCubesByType(
        distributionPlatform:$distributionPlatform,
        cubeListCategory:$cubeListCategory,
        type:$type,
        page:$page,
        pageSize:$pageSize){
        total
        list{
          album{
            id
            contentId
            title
            modelsOfAlbum {
              basic {
                nickName
                webName
                pinyinName
              }
            }
            labels{
              id
              chinese
              pinyin
              level
              parentLabel{
                id
                chinese
                pinyin
              }
            }
            cover314{
              url
            }
          }
        }
      }
      getWebTextLabelConfig(locationKey:$locationKey){
        id
        chinese
        pinyin
        level
        parentLabel{
          id
          pinyin
          chinese
        }
      }
    }`,

  // 通过标签ID获取写真列表
  GET_PHOTO_LIST_BY_LABEL: gql`
    query GET_WEB_CUBE_LIST_BY_LABEL_WITH_PLATFORM(
      $labelId:String,
      $pageSize:Int!,
      $page:Int!,
      $type:CubeType!,
      $distributionPlatform: DistributionPlatform!
      $locationKey:String!){
      getWebCubeListByLabelWithPlatform(
        labelId:$labelId,
        pageSize:$pageSize,
        page:$page,
        type:$type,
        distributionPlatform:$distributionPlatform){
        total
        list{
          album{
            id
            contentId
            title
            modelsOfAlbum {
              basic {
                nickName
                webName
                pinyinName
              }
            }
            labels{
              id
              chinese
              pinyin
              level
              parentLabel{
                id
                chinese
                pinyin
              }
            }
            cover314{
              url
            }
          }
        }
      }
      getWebTextLabelConfig(locationKey:$locationKey){
        chinese
        pinyin
      }
    }`,

  // 通过 contentId 获取专辑详情
  GET_PHOTO_DETAIL_BY_ID: gql`
   query GET_CUBE_BY_TYPE_AND_ID(
     $contentId:String,
     $distributionPlatform: DistributionPlatform!,
     $type:CubeType!
     $cubeListCategory:MomentListCategory!,
     $page:Int!,
     $pageSize:Int!
   ){
      getCubeByTypeAndContentID(
        contentId:$contentId,
        distributionPlatform:$distributionPlatform,
        type:$type
      ){
        prevId
        prevTitle
        nextId
        nextTitle
        album{
          id
          contentId
          title
          createdAt
          introduction
          labels{
                  id
                  chinese
                  pinyin
                }         
          modelsOfAlbum {
            basic{
                   nickName
                   webName
                   headPortrait
                   height
                   bust
                   waist
                   hip
                 }
            }
            photos{
              id,
              url
            }      
        }
      }
     getWebCubesByType(
       distributionPlatform:$distributionPlatform,
       cubeListCategory:$cubeListCategory,
       type:$type,
       page:$page,
       pageSize:$pageSize){
       list{
         album{
           id
           contentId
           title
           cover314 {
             url
           }
         }
       }
     }
   }`,

  //  通过 label 拼音获取 label id
  GET_TEXT_LABEL_BY_PINYIN: gql`
    query GET_TEXT_LABEL_BY_PINYIN_AND_TYPE($pinyin:String!,$type:LabelType!){
      getTextLabelByPinyinAndType(pinyin:$pinyin,type:$type){
        id
        chinese
        pinyin
        level
        parentLabel{
          id
          chinese
          pinyin
        }
      }
    }`,

  //  通过 ID 获取商城商品详情
  GET_SHOP_DETAIL_BY_ID: gql`
    query GET_SHOP_DETAIL_BY_ID($id:String!,$type:CubeType){
      getCubeByTypeAndID(id:$id,type:$type){
        commodity{
          id
          title
          price
          colors
          taobaoUrl
          description
          coverPhoto{
            url
          }
          commodityPhotos{
            url
          }
          similarCommodityList{
            id
            title
            coverPhoto{
              url
            }
            price
          }
        }
      }
    }`,

  // 获取模特id列表
  GET_MODEL_ID_LIST: gql`
    query GET_MODEL_ID_LIST(
      $isSpecial: Boolean!,
      $distributionPlatform: DistributionPlatform!){
      getModelListByContentPublishTime(
        isSpecial:$isSpecial,
        distributionPlatform:$distributionPlatform)
    }`,

  // 获取模特页面数据
  GET_MODEL_DATA: gql`
    query GET_MODEL_DATA(
      $userIdList: [String!]
      $level: Int!,
      $labelPage: Int!,
      $labelPageSize: Int!
    ){
      getPersonListByIdList(userIdList:$userIdList){
        basic{
          id 
          nickName
          headPortraitHttps
          webName
          pinyinName
        }
        albumModelabels{
          id
          chinese
          pinyin
          level
          parentLabel{
            id
            chinese
            pinyin
            level
          }
        }
      }
      getAllLabels(level:$level,page:$labelPage,pageSize:$labelPageSize){
        labelType
        chinese
        id
        pinyin
        level
        deprecated
        parentLabel {
          pinyin
          id
          chinese
          level
          deprecated
        }
      }
    }`,

  // 根据标签获取模特数据
  GET_MODE_DATA_BY_LABEL: gql`
    query GET_WEB_CUBE_LIST_BY_LABEL_WITH_PLAT_FORM(
      $labelId: String,
      $page: Int!,
      $pageSize: Int!,
      $distributionPlatform: DistributionPlatform!,
      $type: CubeType!
      $level: Int!,
      $labelPage: Int!,
      $labelPageSize: Int!
    ){
      getWebCubeListByLabelWithPlatform(
        labelId:$labelId,
        page:$page,
        pageSize:$pageSize,
        distributionPlatform:$distributionPlatform,
        type:$type){
        total
        list{
          person{
            basic{
              id
              nickName
              headPortraitHttps
              webName
              pinyinName
            }
            albumModelabels{
              id
              chinese
              pinyin
              level
              parentLabel{
                id
                chinese
                pinyin
                level
              }
            }
          }
        }
      }
      getAllLabels(level:$level,page:$labelPage,pageSize:$labelPageSize){
        labelType
        chinese
        id
        pinyin
        level
        deprecated
        parentLabel {
          pinyin
          id
          chinese
          level
          deprecated
        }
      }
    }`,

  // 获取模特详情页面数据
  GET_MODEL_DETAIL: gql`
    query GET_MODEL_DETAIL(
      $pinyin: String!,
      $level: Int!,
      $labelPage: Int!,
      $labelPageSize: Int!
    ) {
      getModelByPinyin(pinyin:$pinyin){
        basic{
          id
          headPortraitHttps
          nickName
          webName
          pinyinName
          height
          bust
          waist
          hip
          liveInCity {
            nation
            state
            city
          }
          profession
        }
        signature
      }
      getAllLabels(level:$level,page:$labelPage,pageSize:$labelPageSize){
        labelType
        chinese
        id
        pinyin
        level
        deprecated
        parentLabel {
          pinyin
          id
          chinese
          level
          deprecated
        }
      }
    }`,

  // 获取模特相关专辑列表
  GET_MODEL_ALBUM_LIST: gql`
    query GET_MODEL_ALBUM_LIST(
      $momentsOnly: Boolean!,
      $worksOnly: Boolean!,
      $page: Int!,
      $pageSize: Int!,
      $userId: String!,
      $platform: DistributionPlatform
    ) {
      getCubesByUserId(
        momentsOnly:$momentsOnly,
        worksOnly:$worksOnly,
        page:$page,
        pageSize:$pageSize,
        userId:$userId,
        platform:$platform
      ){
        album{
          numberId
          realsedAt
          realseAtForWeb
          contentId
          updatedAt
          createdAt
          modelsOfAlbum {
            basic {
              nickName
              webName
              pinyinName
            }
          }
          id
          title
          introduction
          photos{
            url
          }
          labels{
            chinese
            pinyin
            english
            numberId
            level
            parentLabel {
              pinyin
            }
          }
          cover314 {
            url
            description
            title
          }
        }
      }
    }`,

  // 获取参与拍摄idList数据
  GET_MOTE_ID_LIST: gql`
    query GET_MOTE_ID_LIST {
      getSpecialModelIdList
  }`,

  // 获取参与拍摄页面数据
  GET_MOTE_DATA: gql`
    query GET_MOTE_DATA($userIdList: [String!]){
      getPersonListByIdList(userIdList:$userIdList){
        basic{
          id
          nickName
          webName
          pinyinName
          headPortraitHttps
        }
        relationship
        followerNumDesc
        signature
      }
    }`,

  // 获取主题拍摄详情页面模特基础数据
  GET_MOTE_DETAIL: gql`
    query GET_MOTE_DETAIL(
      $pinyin: String!
    ){
      getModelByPinyin(pinyin:$pinyin){
        basic{
          id
          headPortraitHttps
          nickName
          webName
          pinyinName
          height
          bust
          waist
          hip
          liveInCity {
            nation
            state
            city
          }
          profession
        }
        signature
      }
    }`,

  // 获取主题拍摄详情页面专辑数据
  GET_MOTE_DETAIL_ALBUM: gql`
    query GET_MOTE_DETAIL_ALBUM(
      $momentsOnly: Boolean!,
      $worksOnly: Boolean!,
      $page: Int!,
      $pageSize: Int!,
      $modelId: String!,
      $platform: DistributionPlatform
    ){
      getCubesByUserId(
        momentsOnly:$momentsOnly,
        worksOnly:$worksOnly,
        page:$page,
        pageSize:$pageSize,
        userId:$modelId,
        platform:$platform
      ){
          album{
            contentId
            id
            title
            modelsOfAlbum {
              basic {
                nickName
                webName
                pinyinName
              }
            }
            labels{
              chinese
              pinyin
              english
              numberId
              level
              parentLabel {
                pinyin
              }
            }
            cover314 {
              url
            }
          }
      }
    }`,

  // 获取主题拍摄详情页面资讯数据
  GET_MOTE_DETAIL_NEWS: gql`
    query GET_MOTE_DETAIL_NEWS(
      $page: Int!,
      $pageSize: Int!,
      $modelId: String!
    ){
      getArticleByModelId(
        modelId:$modelId,
        pageSize:$pageSize,
        page:$page
      ){
        list{
          article{
            title
            numberId
            createdAtForRead
            content{
              content
              contentType
            }
          }
        }
      }
    }`,

  // 获取主题拍摄详情页面动态数据
  GET_MOTE_DETAIL_MOMENT: gql`
    query GET_MOTE_DETAIL_MOMENT(
      $momentsOnly: Boolean!,
      $worksOnly: Boolean!,
      $page: Int!,
      $pageSize: Int!,
      $modelId: String!
    ){
      getCubesByUserId(
        momentsOnly:$momentsOnly,
        worksOnly:$worksOnly,
        page:$page,
        pageSize:$pageSize,
        userId:$modelId
      ){
        moment {
          id
          text
          photos{
            url
          }
          contentType
        }
      }
    }`,

  // 获取资讯详情
 GET_NEWS_DETAIL: gql`
    query GET_NEWS_DETAIL($numberId: Int!){
        getArticleByNumberId(numberId:$numberId){
            title
            id
            createdAtForRead
            content{
              content
              contentType
            }
            nextNumberId
            preNumberId     
        } 
    }`,
  // 通过拼音获取模特id
  GET_MODELID_BY_PINYIN: gql`
    query GET_MODELID_BY_PINYIN($pinyin: String!){
      getModelByPinyin(pinyin:$pinyin){
        basic{
          id
          nickName
        }
      }
    }`
}




// WEBPACK FOOTER //
// ./src/graphql/graphql.js